import commonStrings from "./commonStrings";

const template = {
  locales: ["en", "ro"],
  variables: [
    {
      name: "accent",
      default: "#465272",
      type: "color",
    },
    {
      name: "additionalInfo",
      title: "additional invoice info",
      default: "",
      type: "text",
    },
  ],
  strings: commonStrings,
  globalStyles: `
    * {
      font-family: 'PT Sans' !important;
    }
`,
  styles: {
    itemRow: {
      fontSize: 13,
    },
    itemRowCell: {
      paddingTop: 5,
      paddingBottom: 5,
    },
    itemDescriptionHeaderCell: {
      fontSize: 13,
      fontWeight: "bold",
      textTransform: "uppercase",
      color: "#777777",
      textAlign: "left",
      borderBottomWidth: 2,
      borderBottomStyle: "solid",
      borderBottomColor: "{variables__accent}",
      widthWithTax: "40%",
      widthWithoutTax: "55%",
      whiteSpace: "nowrap",
    },
    itemUnitCostHeaderCell: {
      fontSize: 13,
      fontWeight: "bold",
      textTransform: "uppercase",
      color: "#777777",
      textAlign: "left",
      borderBottomWidth: 2,
      borderBottomStyle: "solid",
      borderBottomColor: "{variables__accent}",
      widthWithTax: "12%",
      widthWithoutTax: "15%",
      whiteSpace: "nowrap",
    },

    itemQtyHeaderCell: {
      fontSize: 13,
      fontWeight: "bold",
      textTransform: "uppercase",
      color: "#777777",
      textAlign: "left",
      borderBottomWidth: 2,
      borderBottomStyle: "solid",
      borderBottomColor: "{variables__accent}",
      widthWithTax: "12%",
      widthWithoutTax: "15%",
      whiteSpace: "nowrap",
    },

    itemAmountHeaderCell: {
      fontSize: 13,
      fontWeight: "bold",
      textTransform: "uppercase",
      color: "#777777",
      textAlign: "left",
      borderBottomWidth: 2,
      borderBottomStyle: "solid",
      borderBottomColor: "{variables__accent}",
      widthWithTax: "12%",
      widthWithoutTax: "15%",
      whiteSpace: "nowrap",
    },

    itemTaxHeaderCell: {
      fontSize: 13,
      fontWeight: "bold",
      textTransform: "uppercase",
      color: "#777777",
      textAlign: "left",
      borderBottomWidth: 2,
      borderBottomStyle: "solid",
      borderBottomColor: "{variables__accent}",
      width: "12%",
      whiteSpace: "nowrap",
    },
    itemAmountWithTaxHeaderCell: {
      fontSize: 13,
      fontWeight: "bold",
      textTransform: "uppercase",
      color: "#777777",
      textAlign: "left",
      borderBottomWidth: 2,
      borderBottomStyle: "solid",
      borderBottomColor: "{variables__accent}",
      width: "12%",
      whiteSpace: "nowrap",
    },
    mainContainer: {
      position: "absolute",
      top: 72,
      left: "50%",
      transform: "translateX(-50%)",
      textAlign: "center",
      fontSize: 48,
      fontWeight: "bold",
      letterSpacing: 4,
      color: "{variables__accent}",
      textTransform: "capitalize",
    },
    invoiceNumberWrapper: {
      position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
      top: 360,
      textAlign: "center",
    },
    invoiceNumberTitle: {
      textTransform: "uppercase",
      color: "#777777",
      fontWeight: "bold",
      fontSize: 14,
      marginBottom: 5,
    },
    invoiceNumber: {
      textTransform: "uppercase",
      color: "#000000",
      fontSize: 14,
    },
    dateOfIssueWrapper: {
      position: "absolute",
      left: "50%",
      transform: "translateX(-150%)",
      top: 300,
      textAlign: "center",
    },
    dateOfIssueTitle: {
      textTransform: "uppercase",
      color: "#777777",
      fontWeight: "bold",
      fontSize: 14,
      marginBottom: 5,
    },
    dateOfIssue: {
      textTransform: "uppercase",
      color: "#000000",
      fontSize: 14,
    },
    dueDateWrapper: {
      position: "absolute",
      left: "50%",
      transform: "translateX(60%)",
      top: 300,
      textAlign: "center",
    },
    dueDateTitle: {
      textTransform: "uppercase",
      color: "#777777",
      fontWeight: "bold",
      fontSize: 14,
      marginBottom: 5,
    },
    dueDate: {
      textTransform: "uppercase",
      color: "#000000",
      fontSize: 14,
    },
    billedToWrapper: {
      position: "absolute",
      left: 76,
      top: 170,
    },
    billedToTitle: {
      textTransform: "uppercase",
      color: "#777777",
      fontWeight: "bold",
      fontSize: 14,
    },
    billedTo: {
      textTransform: "uppercase",
      color: "#000000",
      fontSize: 14,
      maxWidth: 400,
    },
    sellerWrapper: {
      position: "absolute",
      right: 80,
      top: 170,
      maxWidth: 350,
      textAlign: "right",
    },
    sellerName: {
      textTransform: "uppercase",
      color: "#777777",
      fontWeight: "bold",
      fontSize: 14,
    },
    sellerInfo: {
      textTransform: "uppercase",
      color: "#000000",
      fontSize: 14,
      marginBottom: 10,
      maxWidth: 400,
    },
    productTableWrapper: {
      position: "absolute",
      top: 460,
      left: 76,
    },
    productTable: {
      width: 848,
      borderCollapse: "collapse",
    },
    bottomInfoWrapper: {
      marginTop: 40,
      position: "relative",
    },
    bottomLeftInfo: {
      position: "absolute",
    },
    bottomLeftInfoTitle: {
      fontSize: 13,
      fontWeight: "bold",
      textTransform: "uppercase",
      color: "#777777",
      textAlign: "left",
    },
    bottomLeftInfoContent: {
      fontSize: 42,
      fontWeight: "bold",
      textTransform: "uppercase",
      color: "{variables__accent}",
      textAlign: "left",
    },
    bottomRightInfo: {
      position: "absolute",
      left: 500,
    },
    bottomRightInfoTitle: {
      fontSize: 13,
      fontWeight: "bold",
      textTransform: "uppercase",
      color: "#777777",
      textAlign: "left",
      marginTop: 10,
    },
    bottomRightInfoContent: {
      fontWeight: "normal",
      paddingLeft: 5,
    },
    invoiceTotalInOtherCurrency: {
      fontSize: 16,
      display: "{variables__displayTotalInOtherCurrency}",
      displayCondition: (invoiceData) =>
        invoiceData?.config?.otherCurrency &&
        invoiceData?.config?.otherCurrency !== invoiceData?.config?.currency
          ? "block"
          : "none",
    },
    invoiceTotalInOtherCurrencySmall: {
      fontSize: 14,
      marginLeft: 95,
      display: "{variables__displayTotalInOtherCurrency}",
      displayCondition: (invoiceData) =>
        invoiceData?.config?.otherCurrency &&
        invoiceData?.config?.otherCurrency !== invoiceData?.config?.currency
          ? "block"
          : "none",
    },
    bottomRightInfoTitleExchangeRate: {
      fontSize: 13,
      fontWeight: "bold",
      textTransform: "uppercase",
      color: "#777777",
      textAlign: "left",
      marginTop: 10,
      display: "{variables__displayTotalInOtherCurrency}",
      displayCondition: (invoiceData) =>
        invoiceData?.config?.otherCurrency &&
        invoiceData?.config?.otherCurrency !== invoiceData?.config?.currency
          ? "block"
          : "none",
    },
    additionalInfo: {
      whiteSpace: "pre",
      fontSize: 14,
      paddingTop: 40,
    },
    footer: {
      position: "absolute",
      bottom: 48,
      left: 60,
      right: 60,
      fontSize: 13,
      whiteSpace: "pre",
    },
  },
  template: `
  <div style="{styles__mainContainer}">{invoiceTitle}</div>
<div style="{styles__invoiceNumberWrapper}" id="invoice_number">
  <div style="{styles__invoiceNumberTitle}">{invoiceNumberTitle}</div>
  <div style="{styles__invoiceNumber}">{invoiceSeriesAndNumber}</div>
</div>
<div style="{styles__dateOfIssueWrapper}" id="date_of_issue">
  <div style="{styles__dateOfIssueTitle}">{invoiceDateTitle}</div>
  <div style="{styles__dateOfIssue}">{invoiceDate}</div>
</div>
<div style="{styles__dueDateWrapper}" id="due_date">
  <div style="{styles__dueDateTitle}">{invoiceDueDateTitle}</div>
  <div style="{styles__dueDate}">{invoiceDueDate}</div>
</div>
<div style="{styles__billedToWrapper}" id="billed_to">
  <div style="{styles__billedToTitle}">{billedToTitle}</div>
  <div style="{styles__billedTo}">
    <div>{buyerName}</div>
    <div>{buyerAddress}</div>
    <div>{buyerPhone}</div>
    <div>{buyerAdditionalInfo}</div>
  </div>
</div>
<div style="{styles__sellerWrapper}" id="seller">
  <div style="{styles__sellerName}">{sellerTitle}</div>
  <div style="{styles__sellerInfo}">
    <div>{sellerName}</div>
    <div>{sellerAddress}</div>
    <div>{sellerPhone}</div>
    <div>{sellerAdditionalInfo}</div>
  </div>
</div>
<div style="{styles__productTableWrapper}">
  <table style="{styles__productTable}" id="products_table">
    <thead>
      <tr>
        <th style="{styles__itemDescriptionHeaderCell}">{descriptionHeader}</th>
        <th style="{styles__itemUnitCostHeaderCell}">{unitCostHeader}</th>
        <th style="{styles__itemQtyHeaderCell}">{qtyHeader}</th>
        <th style="{styles__itemAmountHeaderCell}">{amountHeader}</th>
        <th style="{styles__itemTaxHeaderCell}" class="hide-for-zero-tax-rate">
          {taxHeader}
        </th>
        <th
          style="{styles__itemAmountWithTaxHeaderCell}"
          class="hide-for-zero-tax-rate"
        >
          {amountWTaxHeader}
        </th>
      </tr>
    </thead>
    <tbody>
      {invoiceItems}
    </tbody>
  </table>
  {addItemButton}      
  <div style="{styles__additionalInfo}">{variables__additionalInfo}</div>
  <div style="{styles__bottomInfoWrapper}">
    <div style="{styles__bottomLeftInfo}">
      <div style="{styles__bottomLeftInfoTitle}">{invoiceTotalTitle}</div>
      <div style="{styles__bottomLeftInfoContent}">{invoiceTotal}</div>
      <div style="{styles__invoiceTotalInOtherCurrency}">
        {invoiceTotalInOtherCurrency}
      </div>
    </div>
    <div style="{styles__bottomRightInfo}">
      <div style="{styles__bottomRightInfoTitle}">
        {invoiceSubtotalTitle}:
        <span style="{styles__bottomRightInfoContent}">
          {invoiceSubtotal}
        </span>
      </div>
      <div style="{styles__bottomRightInfoTitle}">
        {invoiceTaxRateTitle}:
        <span style="{styles__bottomRightInfoContent}">
          {invoiceTaxRate}%
        </span>
      </div>
      <div style="{styles__bottomRightInfoTitle}">
        {invoiceTaxTitle}:
        <span style="{styles__bottomRightInfoContent}"> {invoiceTax} </span>
      </div>
      <div style="{styles__bottomRightInfoTitle}">
        {invoiceTotalTitle}:
        <span style="{styles__bottomRightInfoContent}">
          {invoiceTotal}
          <div style="{styles__invoiceTotalInOtherCurrencySmall}">
            {invoiceTotalInOtherCurrency}
          </div>
        </span>
      </div>
      <div style="{styles__bottomRightInfoTitleExchangeRate}">
        {exchangeRateTitle}:
        <span style="{styles__bottomRightInfoContent}">
          {exchangeRateString}
        </span>
      </div>
    </div>
  </div>
</div>
<div style="{styles__footer}">{footer}</div>
  `,
  itemRow:
    "<tr\n" +
    "style={styles__itemRow}\n" +
    ">\n" +
    "    <td style={styles__itemRowCell}>\n" +
    "    {itemName}\n" +
    "    </td>\n" +
    "    <td style={styles__itemRowCell}>\n" +
    "    {itemUnitCost}\n" +
    "    </td>\n" +
    "    <td style={styles__itemRowCell}>\n" +
    "    {itemQuantity}\n" +
    "    </td>\n" +
    "    <td style={styles__itemRowCell}>\n" +
    "    {itemTotalWithoutTax}\n" +
    "    </td>\n" +
    "    <td\n" +
    "        style={styles__itemRowCell}\n" +
    '        class="hide-for-zero-tax-rate"\n' +
    "    >\n" +
    "    {itemTax}\n" +
    "    </td>\n" +
    "    <td\n" +
    "        style={styles__itemRowCell}\n" +
    '        class="hide-for-zero-tax-rate"\n' +
    "    >\n" +
    "    {itemTotalWithTax}\n" +
    "    </td>\n" +
    "</tr>\n",
};

export default template;
